export enum DataSourceType {
  API = 'API',
  FILE = 'FILE',
  FILESYSTEM = 'FILESYSTEM',
  NO_SQL = 'NO SQL',
  RDBMS = 'RDBMS',
  REAL_TIME_SOURCE = 'REAL TIME SOURCE',
  CONNECTION = 'CONNECTION',
}
